import { toast } from "react-toastify";

const initState = {
    narrative: null,
    currentNarrativeObject: null,
    narrativeChoices: null,
    choicesMade: [],
    choicesMadeName: [],
    isInMinigame: false,
    currentMinigame: null,
    minigamesPlayed: [],
    isAdvanceButtonLocked: false,
    isLoading: false,
    error: false,
    ending: false,
    endingType: null,
    rewards: {
        items: null,
        exp: null
    }
}

const gameReducer = (state = initState, action) => {
    switch (action.type) {
        case 'MAKING_NARRATIVE':
            return {
                ...state,
                isLoading: true
            };
        case 'GET_NARRATIVE_OBJECT':
            return {
                ...state,
                currentNarrativeObject: action.payload
            }
        case 'LOADING_UPDATE_DB_AFTER_END':
            return {
                ...state,
                isLoading: true
            }
        case 'CREATE_NARRATIVE_SUCCESS':
            return {
                ...state,
                ...action.payload,
                narrative: action.narrative,
                chapter: action.chapter,
                isLoading: false
            };
        case 'MAKE_CHOICE':
            console.log(action.minigame)
            console.log(action?.minigame)
            console.log(action.minigame !== null)
            console.log(action?.minigame && action.minigame !== null)
            return action.choice ?
                {
                    ...state,
                    ...action.payload,
                    choicesMade: state.choicesMade.concat(action.choice),
                    choicesMadeName: state.choicesMadeName.concat(action.choiceName)
                }
                :
                {
                    ...state,
                    ...action.payload,
                    minigamesPlayed: action?.minigame && action.minigame !== null ? state.minigamesPlayed.concat(action.minigame) : state.minigamesPlayed
                }
        case 'MAKE_CHOICE_ERROR':
            return action.choice ?
                {
                    ...state,
                    ...action.payload,
                    choicesMade: state.choicesMade.concat(action.choice),
                    choicesMadeName: state.choicesMadeName.concat(action.choiceName)
                }
                :
                {
                    ...state,
                    ...action.payload,
                    minigamesPlayed: action?.minigame && action.minigame !== null ? state.minigamesPlayed.concat(action.minigame) : state.minigamesPlayed
                }
        case 'MAKE_CHOICE_ITEM_SUCCESS':
            toast.info(`Utilizou com sucesso o item - ${action.item}`)
            return {
                ...state,
                ...action.payload,
                isLoading: false,
            }
        case 'MAKE_CHOICE_ITEM_ERROR':
            action.error ? toast.error(`Ocorreu um erro, não foi possível verificar a existência do item - ${action.item} - na sua mochila`) :
                toast.error(`Não tinha - ${action.item} - na sua mochila, logo não pôde usar esse item!`)

            return {
                ...state,
                ...action.payload,
                isLoading: false,
            }
        case 'UPDATE_CHOICES_NUMBER':
            toast.info('Não foi possível atualizar o número das escolhas com as que realizou neste momento. Contudo pode continuar com a narrativa normalmente.')
            return {
                ...state,
                error: action.payload
            };
        case 'UPDATE_DB_AFTER_END_SUCCESS':
            return {
                ...state,
                isLoading: false,
                ending: true,
                endingType: action.endingType,
                narrativeChoices: action.choices,
                rewards: {
                    items: action.rewards.items,
                    exp: action.rewards.exp
                }
            }
        case 'UPDATE_DB_AFTER_END_ERROR':
            return {
                ...state,
                ending: action.payload,
                isLoading: false
            }
        case 'MINIGAME_FINISHED':
            return {
                ...state,
                isInMinigame: false,
            }
        case 'UNLOCK_ADVANCE_BUTTON':
            toast.success(`Boa! O minijogo - ${action.payload} - foi concluído, o botão de avançar foi desbloqueado e já pode continuar a narrativa!`)
            return {
                ...state,
                isAdvanceButtonLocked: false,
            }
        case 'TAKE_PHOTO_SUCCESS':
            toast.success('Foto tirada com sucesso! Poderá ver esta foto com mais detalhe na sua caderneta de viagens mais tarde')
            return {
                ...state,
                isAdvanceButtonLocked: false,
            }
        case 'TAKE_PHOTO_ERROR':
            toast.error('Ocorreu um erro e não foi possível guardar a foto tirada na sua caderneta de viagens')
            return {
                ...state,
                isAdvanceButtonLocked: false,
            }
        case 'QUIT_GAME':
            return {
                ...initState
            }
        default:
            return state
    }
}

export default gameReducer;